import React, { useState, useEffect } from "react";
import { round } from "lodash";
import { Row, Col } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import Summary from "./CoinSummary";
import YncoinSrc from "../../../assets/img/YNcoin.png";
import { getExhangeRate } from "../../../redux/reducers/auth";
import { getYinnExhangeRate } from "../../../redux/reducers/user";

const Packages = (props) => {
  const {
    coins,
    setCoins,
    salesPrice,
    setSalesPrice,
    paymentConfiguration,
    yinnPercentage,
    totalPrice,
  } = props;
  const dispatch = useDispatch();
  const { userCurrency, exchangeRate, translationState } = useSelector(
    (state) => state.user
  );
  const { userLanguage } = useSelector((state) => state.auth);
  const walletTranslation =
    translationState?.[0]?.translations?.wallet?.[userLanguage];
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getYinnExhangeRate());
    dispatch(getExhangeRate(userCurrency));
  }, []);

  const onCoinsChange = (value) => {
    setCoins(value);
    if (value === "") {
      setSalesPrice(0);
    } else {
      const salePrice = round(value / exchangeRate, 2);
      setSalesPrice(salePrice);
    }
  };

  useEffect(() => {
    const salePrice = round(coins / exchangeRate, 2);
    setSalesPrice(salePrice);
  }, [coins, , exchangeRate]);

  return (
    <Row className="packages-main-area">
      <Col
        xs="12"
        xl="6"
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h4 style={{ marginBotton: 20 }}>
          {walletTranslation?.hTwo
            ? walletTranslation?.hTwo
            : "Enter amount to buy or to top up your wallet"}
        </h4>

        <div className="coin-pacakge-box">
          <img className="coin-img" src={YncoinSrc} alt="Yinn coin cryptocurrency icon" />
          <input
            type="number"
            min="0"
            onChange={(e) => onCoinsChange(e.target.value === "" ? "" : Math.max(0, Number(e.target.value) || 0))}
            value={coins}
            name="coins"
            placeholder={walletTranslation?.placeholder ? walletTranslation?.placeholder : "0"}
            className="coin-input"
          />
          <div className="coin-input-box flex items-center">
            <div className="coin-package-price">{salesPrice}</div>
            <span className="ml-1 mt-1">{userCurrency}</span>
          </div>

        </div>
      </Col>
      <Col xs="12" xl="6" style={{ paddingRight: 0 }}>
        <div>
          <div>
            <Summary
              paymentConfiguration={paymentConfiguration}
              salesPrice={salesPrice}
              yinnPercentage={yinnPercentage}
              totalPrice={totalPrice}
              bordered
            />
          </div>
        </div>
      </Col>
    </Row>
    // <div className="pakges_main_wrapper"></div>
  );
};

export default Packages;
